import skill1 from "../assets/skills/html.png";
import skill2 from "../assets/skills/css.png";
import skill3 from "../assets/skills/javascript.png";
import skill4 from "../assets/skills/typescript.png";
import skill5 from "../assets/skills/jquery.png";
import skill6 from "../assets/skills/react.png";
import skill7 from "../assets/skills/next-js.png";
import skill8 from "../assets/skills/angular.png";
import skill9 from "../assets/skills/sass.png";
import skill10 from "../assets/skills/bootstrap.png";
import skill11 from "../assets/skills/csharp.png";
import skill12 from "../assets/skills/node-js.png";
import skill13 from "../assets/skills/firebase.png";
import skill14 from "../assets/skills/git.png";
import skill15 from "../assets/skills/agile.png";
import skill16 from "../assets/skills/jira.png";
import skill17 from "../assets/skills/seo.png";
import skill18 from "../assets/skills/tailwind.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>These are just some of the skills I have in programming and I am constantly improving my skill set to keep up with the demands of the industry. I'm always excited to apply these skills to challenging projects and contribute to the success of the development teams I work on.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={skill1} alt="HTML" />
                                <h5>HTML</h5>
                            </div>
                            <div className="item">
                                <img src={skill2} alt="CSS" />
                                <h5>CSS</h5>
                            </div>
                            <div className="item">
                                <img src={skill3} alt="JavaScript" />
                                <h5>JavaScript</h5>
                            </div>
                            <div className="item">
                                <img src={skill10} alt="Bootstrap" />
                                <h5>Bootstrap</h5>
                            </div>
                            <div className="item">
                                <img src={skill9} alt="Sass" />
                                <h5>Sass</h5>
                            </div>
                            <div className="item">
                                <img src={skill18} alt="Tailwind" />
                                <h5>Tailwind</h5>
                            </div>
                            <div className="item">
                                <img src={skill5} alt="jQuery" />
                                <h5>jQuery</h5>
                            </div>
                            <div className="item">
                                <img src={skill6} alt="React" />
                                <h5>React</h5>
                            </div>
                            <div className="item">
                                <img src={skill7} alt="NextJS" />
                                <h5>NextJS</h5>
                            </div>
                            <div className="item">
                                <img src={skill8} alt="Angular" />
                                <h5>Angular</h5>
                            </div>
                            <div className="item">
                                <img src={skill4} alt="TypeScript" />
                                <h5>TypeScript</h5>
                            </div>
                            <div className="item">
                                <img src={skill11} alt="C Sharp" />
                                <h5>C#</h5>
                            </div>
                            <div className="item">
                                <img src={skill13} alt="Firebase" />
                                <h5>Firebase</h5>
                            </div>
                            <div className="item">
                                <img src={skill12} alt="Node JS" />
                                <h5>Node JS</h5>
                            </div>
                            <div className="item">
                                <img src={skill14} alt="Git" />
                                <h5>Git</h5>
                            </div>
                            <div className="item">
                                <img src={skill15} alt="Agile" />
                                <h5>Agile</h5>
                            </div>
                            <div className="item">
                                <img src={skill16} alt="Jira" />
                                <h5>Jira</h5>
                            </div>
                            <div className="item">
                                <img src={skill17} alt="SEO" />
                                <h5>SEO</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}